module.exports = __webpack_public_path__ + "img/icon-profile.a9bc220e.svg";